module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetMedium.0f32724.jpg";